import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, TextField, IconButton} from 'views/components';
import {Translate} from 'views/module';
import {Clear} from 'views/icons';

const CaregiverBox = (props) => {
  const {data, updateFormData} = props;

  const renderList = (list, field, label) => {
    const filtered = (list || []).filter((el) => el.trim() !== '');
    const items = [...filtered, ''];

    return (
      <Box sx={{padding: '0.5rem 0'}}>
        <Typography variant="subtitle2" style={{marginTop: '0.5rem'}}>{label}</Typography>
        {
          items.map((item, idx) => (
            <Box key={idx} sx={{display: 'flex', alignItems: 'center', mb: 0.5}}>
              <TextField
                value={item}
                onChange={(e) => {
                  const updated = items.map((el, i) => (i === idx ? e : el));
                  updateFormData(field, updated.filter((el) => el.trim() !== ''));
                }}
                fullWidth
                size="small"
                inputProps={{style: {fontSize: 15}}}
              />
              <IconButton
                onClick={() => {
                  const newList = items.filter((_, i) => i !== idx).filter((el) => el.trim() !== '');
                  updateFormData(field, newList);
                }}
                style={{marginLeft: 8}}
              >
                <Clear fontSize="small" />
              </IconButton>
            </Box>
          ))
        }
      </Box>
    );
  };

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.CaregiverBox.Title" />
        </Typography>
      </Box>

      {/* Caregiver Personality */}
      <Typography variant="subtitle2" style={{marginTop: 0}}>
        <Translate expression="profile.CaregiverBox.CaregiverPersonality" />
      </Typography>
      <Box sx={{padding: '0.5rem 0', marginBottom: '0.5rem'}}>
        <TextField
          value={data.caregiverPersonality}
          onChange={(e) => updateFormData('caregiverPersonality', e)}
          multiline
          minRows={3}
          fullWidth
          size="small"
          inputProps={{style: {fontSize: 14}}}
        />
      </Box>

      {/* Skills Required */}
      {
        renderList(
            data.skills,
            'skills',
            <Translate expression="profile.CaregiverBox.Skills" />,
        )
      }
    </Box>
  );
};

CaregiverBox.propTypes = {
  data: PropTypes.shape({
    caregiverPersonality: PropTypes.string,
    skills: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default CaregiverBox;
